export class CountryResultDto {
  code: string;
  country: string;
}
